import React, { Component } from 'react'
import queryString from 'query-string'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import uniq from 'lodash/uniq'

import Pagination from '@components/Pagination'
import Button from '@components/Button'
import { Typeahead } from '@components/Autocomplete'
import Select from '@components/Select'
import Tooltip from '@components/Tooltip'
import DeleteIcon from '@components/Icon/Delete'
import CommentIcon from '@components/Icon/Comment'
import Spinner from '@components/spinner'
import './ComplianceBreach.sass'

class ComplianceBreach extends Component {
  state = {
    list: [],
    page: 1,
    filters: {},
    order: 'DESC',
    orderBy: 'created_at',
    initial: true,
    currentFilter: { key: 'action', value: '' },
    loading: true
  }

  componentDidMount () {
    this.setParameters().then(() => this.populate())
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this.props.location !== prevProps.location &&
      _.isEqual(prevState, this.state)
    ) {
      this.setParameters().then(() => this.populate())
    }
  }

  setParameters = async () => {
    const params = queryString.parse(window.location.search)

    return this.setState({
      page: params.page || 1,
      filters: _.omit(params, ['page'])
    })
  }

  orderBy = async orderBy => {
    let order = 'ASC'
    let initial = false
    if (orderBy === this.state.orderBy) {
      if (this.state.order === 'DESC') {
        if (this.state.initial) {
          order = 'ASC'
        } else {
          orderBy = 'created_at'
          order = 'DESC'
          initial = true
        }
      } else {
        order = 'DESC'
      }
    }
    this.setState({ initial, order, orderBy }, () => this.populate())
  }

  populate = async () => {
    this.setState({ loading: true })

    await this.props.complianceBreachStore.getAll(
      this.state.filters,
      this.state.order,
      this.state.orderBy,
      (this.state.page - 1) * 25,
      this.props.employeeStore.employees
    )
    const list = this.props.complianceBreachStore.complianceBreachList.rows
    const expertIds = []
    for (const r of list) {
      if (r.expertId) {
        expertIds.push(r.expertId)
      }
    }

    const experts = await this.getExperts(expertIds)
    for (const e of experts) {
      list.forEach(breach => {
        if (breach.expertId === e.id) {
          breach.expert = e.fullName
        }
      })
    }

    this.setState({ list, loading: false }, () => {
      const url = new URL(
        `${window.location.origin}${window.location.pathname}`
      )
      url.searchParams.set('page', this.state.page)
      Object.keys(this.state.filters).forEach(key => {
        url.searchParams.set(key, this.state.filters[key])
      })
      window.history.pushState({}, '', url)
    })
  }

  getEmployee = employeeId => {
    if (!employeeId) {
      return {}
    }
    const employee = this.props.employeeStore.employees.filter(
      e => e.value === employeeId
    )

    return employee[0]
  }

  getAccountManager = employeeId => {
    if (!employeeId) {
      return {}
    }

    const emp = this.getEmployee(employeeId)

    if (emp?.teamId) {
      const accountManager = this.props.employeeStore.employees.filter(
        e => e.teamId === emp.teamId && e.positionId === 5 && e.active
      )

      return accountManager[0]
    } else {
      return {}
    }
  }

  getExperts = async expertIds => {
    if (!expertIds) {
      return []
    }

    const expertNames = await this.props.expertStore.getExpertNameList(
      expertIds
    )

    return expertNames
  }

  addFilter = async e => {
    e.preventDefault()

    if (this.state.currentFilter.value) {
      this.setState(
        {
          currentFilter: {
            ...this.state.currentFilter,
            value:
              this.state.currentFilter.key === 'accManager' ||
              this.state.currentFilter.key === 'team'
                ? 'None'
                : ''
          },
          filters: {
            ...this.state.filters,
            [this.state.currentFilter.key]: this.state.currentFilter.value
          }
        },
        () => this.populate()
      )
    }
  }

  confirm = (id, status) => async () => {
    this.setState({ loading: true }, async () => {
      await this.props.complianceBreachStore.confirm(id, status)
      await this.populate()
      this.setState({ loading: false })
    })
  }

  renderFilters = () => {
    const options = [
      { label: 'Action', value: 'action' },
      { label: 'Rule', value: 'rule' },
      { label: 'User', value: 'userId' },
      { label: 'Expert', value: 'expertId' },
      { label: 'Team', value: 'team' },
      { label: 'Acc. Manager', value: 'accManager' }
    ]

    return (
      <div className="cb-filters">
        <div className="cb-filters-title">Filters</div>
        <form className="cb-filters-selection" onSubmit={this.addFilter}>
          <Select
            value={this.state.currentFilter.key}
            options={options}
            onChange={e => {
              if (this.state.currentFilter.key !== e.target.value) {
                this.setState({
                  currentFilter: {
                    key: e.target.value,
                    label: e.target.label,
                    value:
                      e.target.value === 'accManager' ||
                      e.target.value === 'team'
                        ? 'None'
                        : ''
                  }
                })
              }
            }}
          />
          {this.state.currentFilter.key === 'expertId' ? (
            <Typeahead
              value={this.state.currentFilter.value}
              loadOptions={this.props.complianceBreachStore.expertSearch}
              onChange={selectedRecord => {
                this.setState({
                  currentFilter: {
                    ...this.state.currentFilter,
                    value: selectedRecord
                  }
                })
              }}
              onInputValueChange={inputValue => {
                this.props.complianceBreachStore.expertSearch(inputValue)
                this.setState({
                  currentFilter: {
                    ...this.state.currentFilter,
                    value: inputValue
                  }
                })
              }}
            />
          ) : this.state.currentFilter.key === 'userId' ? (
            <Typeahead
              value={this.state.currentFilter.value}
              loadOptions={this.props.complianceBreachStore.userSearch}
              onChange={selectedRecord => {
                this.setState({
                  currentFilter: {
                    ...this.state.currentFilter,
                    value: selectedRecord
                  }
                })
              }}
              onInputValueChange={inputValue => {
                this.props.complianceBreachStore.userSearch(inputValue)
                this.setState({
                  currentFilter: {
                    ...this.state.currentFilter,
                    value: inputValue
                  }
                })
              }}
            />
          ) : this.state.currentFilter.key === 'team' ? (
            <Select
              value={this.state.currentFilter.value}
              options={[
                { label: 'None', value: 'None' },
                ...uniq(
                  this.props.employeeStore.employees
                    .filter(e => e.team)
                    .map(e => e.team)
                ).map(e => ({
                  label: e,
                  value: e
                }))
              ]}
              onChange={e => {
                if (
                  this.state.currentFilter.value !== e.target.value &&
                  e.target.value
                ) {
                  this.setState({
                    currentFilter: {
                      ...this.state.currentFilter,
                      value: e.target.value
                    }
                  })
                }
              }}
            />
          ) : this.state.currentFilter.key === 'accManager' ? (
            <Select
              value={this.state.currentFilter.value}
              options={[
                { label: 'None', value: 'None' },
                ...this.props.employeeStore.employees
                  .filter(e => e.positionId === 5 && e.teamId && e.active)
                  .map(e => ({
                    label: e.label,
                    value: e.label
                  }))
              ]}
              onChange={e => {
                if (
                  this.state.currentFilter.value !== e.target.value &&
                  e.target.value
                ) {
                  this.setState({
                    currentFilter: {
                      ...this.state.currentFilter,
                      value: e.target.value
                    }
                  })
                }
              }}
            />
          ) : (
            <input
              onChange={e =>
                this.setState({
                  currentFilter: {
                    ...this.state.currentFilter,
                    value: e.target.value
                  }
                })
              }
              value={this.state.currentFilter.value}
              style={{ height: 35, marginLeft: 10, width: 190 }}
            />
          )}
          <Button className="cb-filters-button" onClick={this.addFilter}>
            Add Filter
          </Button>
        </form>
        <div className="cb-filters-chip-wrapper">
          {Object.keys(this.state.filters).map(key => (
            <div className="cb-filters-chip">
              <div className="cb-filters-chip-label">
                {options.filter(o => o.value === key)[0]?.label}:{' '}
                {this.state.filters[key]}
              </div>
              <a
                className="cb-filters-chip-remove"
                onClick={e => {
                  e.preventDefault()
                  this.setState(
                    {
                      page: 1,
                      filters: _.omit(this.state.filters, [key])
                    },
                    () => this.populate()
                  )
                }}>
                <DeleteIcon />
              </a>
            </div>
          ))}
        </div>
      </div>
    )
  }

  render () {
    const { complianceBreachList } = this.props.complianceBreachStore

    return (
      <DocumentTitle title="Employee Compliance Breach | Atheneum Partners">
        <div className="cb-wrapper">
          <div className="cb-title">
            <h3>Potential Compliance Breach List</h3>
          </div>
          {this.renderFilters()}
          <div className="cb-content">
            {this.state.loading ? (
              <Spinner center />
            ) : (
              <>
                <table className="table-wrapper cb-table">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Team</th>
                      <th>Acc. Manager</th>
                      <th>Expert</th>
                      <th>Action</th>
                      <th>Rule</th>
                      <th>Date</th>
                      <th>Comments</th>
                      <th
                        style={{
                          width: 200,
                          minWidth: 200
                        }}>
                        Confirmation
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.list.map(cb => {
                      const e = this.getEmployee(cb.userId)
                      const accountManager = this.getAccountManager(cb.userId)

                      return (
                        <tr
                          key={cb.id}
                          className={
                            cb.confirmed === true
                              ? 'green'
                              : cb.confirmed === false
                              ? 'red'
                              : ''
                          }>
                          <td>{e?.label}</td>
                          <td>{e?.team}</td>
                          <td>{accountManager?.label}</td>
                          <td>
                            {cb.expert ? (
                              <a href={`/expert/${cb.expertId}`}>{cb.expert}</a>
                            ) : (
                              ''
                            )}
                          </td>
                          <td>{cb.action}</td>
                          <td>{cb.rule}</td>
                          <td>
                            {moment(cb.created_at).format(
                              'DD-MM-YYYY HH:mm:ss'
                            )}
                          </td>
                          <td>
                            {cb.comment.length ? (
                              <Tooltip
                                sherlock
                                tooltip={cb.comment.map(c => (
                                  <>
                                    <b>Breach Comment: </b>
                                    <br />
                                    {c.comment}
                                    {cb.ruleModel.comment && (
                                      <>
                                        {' '}
                                        <br />
                                        <b>Rule Comment: </b>
                                        <br />
                                        {cb.ruleModel.comment}
                                      </>
                                    )}
                                    <br />
                                  </>
                                ))}
                                placement="top">
                                <CommentIcon />
                              </Tooltip>
                            ) : null}
                          </td>
                          <td>
                            {cb.confirmed === null && (
                              <>
                                <Button
                                  primary
                                  onClick={this.confirm(cb.id, true)}
                                  className="cb-action-button">
                                  Approve
                                </Button>
                                <Button
                                  onClick={this.confirm(cb.id, false)}
                                  className="cb-action-button decline">
                                  Reject
                                </Button>
                              </>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
                <div className="bottom-container">
                  <Pagination
                    total={complianceBreachList.count}
                    perPage={25}
                    page={parseInt(this.state.page, 10)}
                    onChange={page => {
                      this.setState({ page }, () => {
                        this.populate()
                      })
                    }}
                  />
                  <div className="results">
                    Showing{' '}
                    <b>
                      {(this.state.page - 1) * 25 + 1} to{' '}
                      {complianceBreachList.count < this.state.page * 25
                        ? complianceBreachList.count
                        : this.state.page * 25}
                    </b>{' '}
                    of {complianceBreachList.count} Results
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject(
  'complianceBreachStore',
  'employeeStore',
  'expertStore'
)(observer(ComplianceBreach))
